module.exports = __webpack_public_path__ + "static/img/icon_cloud.8d27f0a1.svg";